import React from 'react';
export function ProofBar() {
  return <div className="bg-gradient-to-br from-card-bg to-[rgba(107,0,182,0.3)] border-y border-[rgba(194,0,111,0.3)] py-[25px] px-5" data-id="element-269">
      <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-5 text-center" data-id="element-270">
        <div className="flex flex-col items-center" data-id="element-271">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-272">
            40%
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-273">
            Reducción de ansiedad Basado en protocolos de neurociencia cognitiva
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-274">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-275">
            4 Vol.
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-276">
            Colección completa — El Camino a la Recuperación
          </p>
        </div>
        <div className="flex flex-col items-center" data-id="element-277">
          <strong className="block font-heading font-black text-[2rem] text-gradient-magenta leading-none mb-1" data-id="element-278">
            21 días
          </strong>
          <p className="text-[0.85rem] text-white/65 mt-1" data-id="element-279">
            Prácticas diarias de minutos para reprogramar el ciclo
          </p>
        </div>
      </div>
    </div>;
}